export default "__VITE_ASSET__Bt9UH7LL__"